<div class="payment-alert m-3" [matTooltip]="tooltip">
  {{ text }}
</div>
